import { Keyboard, Lock, User } from "lucide-react";
import React, { useState } from "react";

export default function QuizLoginModal({
  open = true,
  onNext = (payload) => (console.log(payload)),
}) {
  const [userId, setUserId] = useState("111111");
  const [password, setPassword] = useState("111111");
  const [mode, setMode] = useState("Normal"); // Normal | Illogically

  if (!open) return null;

  const handleNext = () => {
    onNext("startInstruction");
  };

  return (
    
        <div style={styles.center}>
          <div style={styles.card}>
            <div style={styles.cardHeader}>Quiz Login</div>

            <div style={styles.cardBody}>
              {/* Username */}
              <div style={styles.field}>
                <div style={styles.iconBox}><User size={20}/></div>
                <input
                  style={styles.input}
                  value={userId}
                  onChange={(e) => setUserId(e.target.value)}
                  placeholder="User ID"
                />
                <div style={styles.rightIcon}><Keyboard size={20}/></div>
              </div>

              {/* Password */}
              <div style={styles.field}>
                <div style={styles.iconBox}><Lock size={20} /></div>
                <input
                  style={styles.input}
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Password"
                />
                <div style={styles.rightIcon}><Keyboard size={20}/></div>
              </div>

              {/* Toggle + Next */}
              <div style={styles.footerRow}>
                {/* <div style={styles.toggleWrap}>
                  <span style={styles.smallText}>Illogically</span>

                  <button
                    type="button"
                    style={{
                      ...styles.toggle,
                      justifyContent: mode === "Normal" ? "flex-end" : "flex-start",
                    }}
                    onClick={() =>
                      setMode((prev) => (prev === "Normal" ? "Illogically" : "Normal"))
                    }
                  >
                    <span style={styles.knob} />
                  </button>

                  <span style={styles.smallText}>Normal</span>
                </div> */}
<div></div>
                <button style={styles.nextBtn} onClick={handleNext}>
                  Start Test
                </button>
              </div>
            </div>
          </div>
        </div>
     
  );
}

/* ✅ Styles (same look) */
const styles = {
  backdrop: {
    position: "fixed",
    inset: 0,
    backgroundColor: "rgba(0,0,0,0.25)",
    zIndex: 9999,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: 20,
  },
  modal: {
    width: "95vw",
    height: "92vh",
    backgroundColor: "#fff",
    borderRadius: 10,
    boxShadow: "0 10px 35px rgba(0,0,0,0.25)",
    position: "relative",
    overflow: "hidden",
  },
  topBar: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    height: 70,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    pointerEvents: "none",
  },
  title: {
    fontSize: 26,
    fontWeight: 600,
    color: "#222",
    pointerEvents: "auto",
  },
  closeBtn: {
    position: "absolute",
    right: 18,
    top: 16,
    padding: "10px 18px",
    borderRadius: 999,
    border: "1px solid #eee",
    backgroundColor: "#fff",
    cursor: "pointer",
    fontWeight: 600,
    boxShadow: "0 6px 16px rgba(0,0,0,0.08)",
    pointerEvents: "auto",
  },
  center: {
    width: "100%",
    height: "100%",
    display: "grid",
    placeItems: "center",
  },
  card: {
    width: 420,
    maxWidth: "92vw",
    borderRadius: 6,
    overflow: "hidden",
    backgroundColor: "#f6f6f6",
    boxShadow: "0 10px 25px rgba(0,0,0,0.12)",
  },
  cardHeader: {
    backgroundColor: "#cfcfcf",
    padding: "10px 14px",
    fontWeight: 700,
    color: "#222",
    textAlign: "center",
  },
  cardBody: {
    padding: 18,
  },
  field: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    marginBottom: 14,
  },
  iconBox: {
    width: 34,
    textAlign: "center",
    fontSize: 18,
  },
  input: {
    flex: 1,
    height: 38,
    borderRadius: 0,
    border: "1px solid #d0d0d0",
    padding: "0 12px",
    outline: "none",
    backgroundColor: "#eef1f4",
    fontSize: 14,
  },
  rightIcon: {
    width: 34,
    textAlign: "center",
    opacity: 0.7,
  },
  footerRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: 10,
  },
  toggleWrap: {
    display: "flex",
    alignItems: "center",
    gap: 12,
  },
  smallText: {
    fontSize: 12,
    color: "#333",
    fontWeight: 600,
  },
  toggle: {
    width: 70,
    height: 30,
    borderRadius: 999,
    backgroundColor: "#bdbdbd",
    border: "1px solid #a9a9a9",
    display: "flex",
    alignItems: "center",
    padding: 3,
    cursor: "pointer",
    boxShadow: "inset 0 2px 6px rgba(0,0,0,0.18)",
  },
  knob: {
    width: 26,
    height: 26,
    borderRadius: "50%",
    backgroundColor: "#fff",
    boxShadow: "0 6px 15px rgba(0,0,0,0.20)",
  },
  nextBtn: {
    padding: "12px 28px",
    borderRadius: 999,
    border: "none",
    backgroundColor: "#fff",
    cursor: "pointer",
    fontWeight: 700,
    boxShadow: "0 8px 18px rgba(0,0,0,0.12)",
  },
};
